// src/services/firebase/contactService.js - שירות לשמירת פניות
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebaseConfig'

/**
 * שמירת פנייה חדשה במסד הנתונים
 * @param {Object} contactData - נתוני הפנייה
 * @returns {Promise<string>} - מזהה המסמך שנוצר
 */
export const saveContact = async (contactData) => {
  try {
    // הכנת הנתונים לשמירה
    const dataToSave = {
      name: contactData.name?.trim() || '',
      email: contactData.email?.trim()?.toLowerCase() || '',
      phone: contactData.phone?.trim() || '',
      subject: contactData.subject?.trim() || '',
      message: contactData.message?.trim() || '',
      category: contactData.category || 'פנייה כללית',
      createdAt: serverTimestamp(),
      status: 'חדש',
      source: contactData.source || 'אתר גמלנט AI', // 🆕 השתמש ב-source מהפרמטר
      sourceContext: contactData.sourceContext || null // 🆕 הוסף את ה-sourceContext
    };

    // שמירה ב-Firestore
    const docRef = await addDoc(collection(db, 'leads'), dataToSave);
    
    return docRef.id;
    
  } catch (error) {
    console.error('❌ שגיאה בשמירת הפנייה:', error);
    
    if (error.code === 'permission-denied') {
      throw new Error('אין הרשאה לשמירת נתונים. אנא נסו שוב מאוחר יותר.');
    } else if (error.code === 'unavailable') {
      throw new Error('השירות אינו זמין כרגע. אנא נסו שוב.');
    } else {
      throw new Error('אירעה שגיאה בשמירת הפנייה. אנא נסו שוב.');
    }
  }
};

/**
 * קבלת רשימת הפניות (לדף ניהול)
 * @param {number} limit - מספר התוצאות המקסימלי
 * @returns {Promise<Array>} - רשימת הפניות
 */
export const getContacts = async (limit = 50) => {
  try {
    const { query, orderBy, getDocs, limitToLast } = await import('firebase/firestore');
    
    const contactsQuery = query(
      collection(db, 'leads'),
      orderBy('createdAt', 'desc'),
      limitToLast(limit)
    );
    
    const querySnapshot = await getDocs(contactsQuery);
    const contacts = [];
    
    querySnapshot.forEach((doc) => {
      contacts.push({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date()
      });
    });
    
    return contacts;
    
  } catch (error) {
    console.error('❌ שגיאה בקבלת הפניות:', error);
    throw new Error('אירעה שגיאה בטעינת הפניות.');
  }
};

/**
 * עדכון סטטוס פנייה
 * @param {string} contactId - מזהה הפנייה
 * @param {string} newStatus - סטטוס חדש
 * @returns {Promise<void>}
 */
export const updateContactStatus = async (contactId, newStatus) => {
  try {
    const { doc, updateDoc } = await import('firebase/firestore');
    
    const contactRef = doc(db, 'leads', contactId);
    await updateDoc(contactRef, {
      status: newStatus,
      updatedAt: serverTimestamp()
    });
    
 
  } catch (error) {
    console.error('❌ שגיאה בעדכון הסטטוס:', error);
    throw new Error('אירעה שגיאה בעדכון הסטטוס.');
  }
};

// אפשרויות סטטוס בעברית
export const contactStatuses = {
  NEW: 'חדש',
  IN_PROGRESS: 'בטיפול',
  CONTACTED: 'נוצר קשר',
  RESOLVED: 'טופל',
  CLOSED: 'סגור'
};

// קטגוריות פניות בעברית
export const contactCategories = {
  GENERAL: 'פנייה כללית',
  SUPPORT: 'תמיכה טכנית',
  ADVICE: 'ייעוץ פיננסי',
  PARTNERSHIP: 'שיתוף פעולה',
  FEEDBACK: 'משובים והצעות'
};